import { useRef } from 'react';
import { checkShowLockIcon } from '../../../helpers/vod';
import { __ } from '../../../translations';
import { useInView } from 'react-intersection-observer';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import { Poster } from './elements';
import { TabLists } from './TabLists';
import { useDetailOverlayActions } from '../hooks/useDetailOverlayActions';
import { TvodModal } from './elements/TvodModal';
import { iDetailOverlayProps } from '../types/iDetailOverlay';
import { DetailOverlayContent } from './DetailOverlayContent';

export const DetailOverlay: React.FC<iDetailOverlayProps> = ({ item, seasons, episodes, promotionProviderImages }) => {
    // refs
    const scrollRef = useRef(null);
    const { ref, inView } = useInView({ threshold: 0.5 });
    const hasTrailerUrl = item?.trailer || item?.vodTrailer ? true : false;

    // hooks
    const {
        isLoading,
        showTvodPurchaseOverlay,
        openQRModal,
        showAutoTrailer,
        showTrailer,
        isMuted,
        trailerUrl,
        runtimeLength,
        showMoviePoster,
        priceInfo,
        isTvod,
        isRented,
        productId,
        expiryDate,
        toggleWatchlistMutation,
        isAdded,
        setShowTvodPurchaseOverlay,
        setOpenQRModal,
        handleShowTrailer,
        closeTrailerPlayer,
        handleGenerateOtpApi,
        handleToggleWatchlistItem,
        setShowTrailer,
        handleMute,
        setRuntimeLength,
        handlePurchase,
    } = useDetailOverlayActions(item, inView, scrollRef, promotionProviderImages);
    const { paidVsFree } = useConfigurationSections();
    const enableLockIcon = paidVsFree?.lockIconEnable || false;
    const isLocked = checkShowLockIcon(item?.subscriptionGuids ?? []) && enableLockIcon;
    const tvodInfo = { ...priceInfo, productId: productId };

    return (
        <div>
            <div ref={scrollRef} tabIndex={0}></div>
            <>
                <TvodModal
                    showTvodPurchaseOverlay={showTvodPurchaseOverlay}
                    setShowTvodPurchaseOverlay={setShowTvodPurchaseOverlay}
                    tvodInfo={tvodInfo}
                    item={item}
                    handlePurchase={handlePurchase}
                    openQRModal={openQRModal}
                    setOpenQRModal={setOpenQRModal}
                />

                <Poster
                    showMoviePoster={showMoviePoster}
                    showAutoTrailer={showAutoTrailer}
                    item={item}
                    trailerUrl={trailerUrl}
                    isMuted={isMuted}
                    handleShowTrailer={handleShowTrailer}
                />

                <DetailOverlayContent
                    isTvod={isTvod}
                    isLocked={isLocked}
                    isRented={isRented}
                    isAdded={isAdded}
                    isMuted={isMuted}
                    isLoading={isLoading}
                    hasTrailerUrl={hasTrailerUrl}
                    showTrailer={showTrailer}
                    item={item}
                    episodes={episodes}
                    tvodInfo={tvodInfo}
                    expiryDate={expiryDate}
                    runtimeLength={runtimeLength}
                    promotionProviderImages={promotionProviderImages}
                    handleGenerateOtpApi={handleGenerateOtpApi}
                    handleToggleWatchlistItem={handleToggleWatchlistItem}
                    toggleWatchlistMutation={toggleWatchlistMutation}
                    handleShowTrailer={handleShowTrailer}
                    closeTrailerPlayer={closeTrailerPlayer}
                    setShowTrailer={setShowTrailer}
                    handleMute={handleMute}
                />

                <TabLists ref={ref} item={item} setRuntimeLength={setRuntimeLength} seasons={seasons} />
            </>
        </div>
    );
};
